import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-603d3c71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "w-11/12 pt-16 bg-white sm:w-96 max-w-96" }
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Create An Account", -1))
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = { class: "space-y-6 text-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " From time to time, we can email you about scorecards, but you can tell us which promotions you like to watch: ", -1))
const _hoisted_9 = { class: "grid grid-cols-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "We will let you know when:", -1))
const _hoisted_11 = { class: "flex space-x-2" }
const _hoisted_12 = { class: "space-y-6 text-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Just a quick review before you create your account", -1))
const _hoisted_14 = { class: "mt-2 space-y-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Email:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Display Name:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "We will send you emails about the following promotions:", -1))
const _hoisted_18 = { class: "mt-2 text-sm" }
const _hoisted_19 = { class: "mt-2 text-sm" }
const _hoisted_20 = { class: "flex space-x-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Already a member? "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "font-black text-primary hover:text-primary-dark"
  }, "Login now")
], -1))

import Button from '@/components/UI/Button.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/users';
import { computed, onErrorCaptured, ref, toRefs } from 'vue';
import FloatingHeaderTextField from '@/components/Inputs/FloatingHeaderTextField.vue';
import { useBrandStore } from '@/store/brands';
import Checkbox from '@/components/Inputs/Checkbox.vue';
import { UserRegistration } from '@/typings/user';
import Logo from '@/components/UI/Logo.vue';

interface Props {
  email?: string;
  nextUrl?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    email: { default: '' },
    nextUrl: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { email: string, nextUrl: string }

const router = useRouter();



const { email } = toRefs(props);

const user = ref<UserRegistration>({
  email: email.value,
  username: '',
  password: '',
  checkPassword: '',
  emailPreferences: {
    ScorecardOpened: true,
    ScorecardLockingSoon: true,
    Brands: {},
  },
});

const validationErrors = ref({
  email: '',
  username: '',
  password: '',
});

const tabIndex = ref(0);

const userStore = useUserStore();
const brandStore = useBrandStore();

const { brands } = toRefs(brandStore);
const selectableBrands = computed(() =>
  brands.value.filter((b) => b.Name !== 'None')
);
brandStore.getBrands().then(() => {
  brands.value.forEach(
    (el) => (user.value.emailPreferences.Brands[el.Name] = true)
  );
});

const brandNames = computed(() =>
  Object.keys(user.value.emailPreferences.Brands)
    .filter((b) => b !== 'None' && user.value.emailPreferences.Brands[b])
    .join(', ')
);

const emailText = computed(() => {
  let text = 'Never';
  if (
    user.value.emailPreferences.ScorecardOpened ||
    user.value.emailPreferences.ScorecardLockingSoon
  ) {
    const parts = [];
    text = 'When ';
    if (user.value.emailPreferences.ScorecardOpened)
      parts.push('a scorecard opens');
    if (user.value.emailPreferences.ScorecardLockingSoon)
      parts.push('a scorecard is about to lock');

    text = `${text} ${parts.join(' or ')}`;
  }
  return text;
});

if (userStore.user) {
  router.push({ name: 'Scorecards' });
}

function validateUser() {
  let error = false;
  if (user.value.username.length === 0) {
    error = true;
    validationErrors.value.username = 'Username cannot be blank';
  }

  if (user.value.username === user.value.email) {
    error = true;
    validationErrors.value.username =
      'Username must not be the same as your email';
  } else if (user.value.username.match(/([^a-zA-Z0-9_\-.\s])/g)) {
    error = true;
    validationErrors.value.username =
      'Username can only include letters, numbers, spaces and _, -, or .';
  }

  if (user.value.email.length === 0) {
    error = true;
    validationErrors.value.email = 'Email cannot be blank';
  }

  if (!user.value.email.match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/g)) {
    error = true;
    validationErrors.value.email = 'Must be a valid email address';
  }

  if (user.value.username.length === 0) {
    error = true;
    validationErrors.value.username = 'Username cannot be blank';
  }

  if (user.value.password.length < 8) {
    error = true;
    validationErrors.value.password =
      'Password must be at least 8 characters in length';
  }

  if (user.value.checkPassword !== user.value.password) {
    error = true;
    validationErrors.value.password = 'Passwords do not match';
  }
  return !error;
}

function goToEmailPreferencess() {
  if (validateUser()) {
    tabIndex.value = 1;
  }
}

async function register() {
  if (validateUser()) {
    const res = await userStore.register(user.value);
    if (res.userCreated) {
      const success = await userStore.login(
        user.value.email,
        user.value.checkPassword
      );
      if (success) {
        if (props.nextUrl) {
          router.push(props.nextUrl);
        } else {
          router.push({ name: 'Scorecards' });
        }
      }
    } else {
      tabIndex.value = 0;
      validationErrors.value.email = res.emailError || '';
      validationErrors.value.username = res.userError || '';
      validationErrors.value.password = res.passwordError || '';
    }
  } else {
    tabIndex.value = 0;
  }
}

onErrorCaptured((err) => {
  console.error(err);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "px-4 space-y-6 text-center",
          onSubmit: _withModifiers(register, ["prevent"])
        }, [
          _hoisted_5,
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(FloatingHeaderTextField, {
              title: "Email",
              modelValue: user.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.email) = $event)),
              "validation-error": validationErrors.value.email
            }, null, 8, ["modelValue", "validation-error"]),
            _createVNode(FloatingHeaderTextField, {
              title: "Display Name",
              modelValue: user.value.username,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.username) = $event)),
              "max-length": "30",
              "validation-error": validationErrors.value.username
            }, null, 8, ["modelValue", "validation-error"]),
            _createVNode(FloatingHeaderTextField, {
              title: "Password",
              modelValue: user.value.password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.password) = $event)),
              type: "password"
            }, null, 8, ["modelValue"]),
            _createVNode(FloatingHeaderTextField, {
              title: "Confirm Password",
              modelValue: user.value.checkPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.checkPassword) = $event)),
              "validation-error": validationErrors.value.password,
              type: "password"
            }, null, 8, ["modelValue", "validation-error"]),
            _createVNode(Button, {
              label: "Next",
              onClick: _withModifiers(goToEmailPreferencess, ["prevent"]),
              type: "primary",
              class: "w-full py-3 font-bold rounded text-md"
            }, null, 8, ["onClick"])
          ], 512), [
            [_vShow, tabIndex.value === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectableBrands), (brand) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: brand.CompanyId
                }, [
                  _createVNode(Checkbox, {
                    title: brand.Name,
                    modelValue: user.value.emailPreferences.Brands[brand.Name],
                    "onUpdate:modelValue": ($event: any) => ((user.value.emailPreferences.Brands[brand.Name]) = $event)
                  }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ]),
            _hoisted_10,
            _createElementVNode("div", null, [
              _createVNode(Checkbox, {
                title: "A scorecard is opened",
                modelValue: user.value.emailPreferences.ScorecardOpened,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.emailPreferences.ScorecardOpened) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(Checkbox, {
                title: "A scorecard is locking soon",
                modelValue: user.value.emailPreferences.ScorecardLockingSoon,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.emailPreferences.ScorecardLockingSoon) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(Button, {
                label: "Back",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (tabIndex.value--), ["prevent"])),
                type: "secondary",
                class: "w-full py-3 font-bold rounded text-md"
              }),
              _createVNode(Button, {
                label: "Next",
                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (tabIndex.value++), ["prevent"])),
                type: "primary",
                class: "w-full py-3 font-bold rounded text-md"
              })
            ])
          ], 512), [
            [_vShow, tabIndex.value === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(user.value.email), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(user.value.username), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(brandNames)), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(emailText)), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(Button, {
                label: "Back",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (tabIndex.value--), ["prevent"])),
                type: "secondary",
                class: "w-full py-3 font-bold rounded text-md"
              }),
              _createVNode(Button, {
                label: "Create Account",
                type: "primary",
                class: "w-full py-3 font-bold rounded text-md"
              })
            ])
          ], 512), [
            [_vShow, tabIndex.value === 2]
          ]),
          _hoisted_21
        ], 40, _hoisted_4)
      ])
    ])
  ]))
}
}

})